import styled from 'styled-components';
import { rgba } from 'polished';
import { FormControlLabel, Select, Dialog } from '@material-ui/core';

// CONSTANTS
import { WHITE, MAIN_BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const DialogStyled = styled(Dialog)`
  .filters-dialog,
  &.filters-dialog {
    .MuiDialog-paper {
      background-color: transparent;
    }

    &__header {
      padding: 20px 16px;
      color: ${p => p.theme.palette.primary.contrastText};

      ${breakpoints.down('sm')} {
        padding: 4px 6px;
      }
    }

    &__close-button {
      color: ${p => p.theme.palette.primary.contrastText};
      font-size: 37px;
      height: 50px;
      width: 50px;
      float: right;
      padding: 0;
    }

    &__content,
    &__footer {
      padding-right: 15px;
      padding-left: 15px;
      color: ${p => p.theme.palette.primary.contrastText};
      max-width: 1140px;
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
    }

    &__content {
      padding-top: 15px;

      ${breakpoints.down('sm')} {
        padding-top: 30px;
      }

      &--iframe {
        flex-grow: 0;
      }

      &-title {
        margin-top: 40px;

        ${breakpoints.down('sm')} {
          margin-top: 30px;
        }
      }

      &-filters {
        padding-top: 12px;
        margin-bottom: 32px;

        ${breakpoints.down('sm')} {
          padding-top: 16px;
          margin-bottom: 40px;
        }
      }
    }

    &__reset-filters {
      color: ${p => p.theme.palette.primary.contrastText};
      border-color: ${WHITE};
    }

    .content-filters,
    &.content-filters {
      &__checkboxes {
        ${breakpoints.down('sm')} {
          padding-top: 16px;
        }
      }

      &__buttons {
        margin-top: 64px;
      }
    }
  }
`;

export const StyledContolLabel = styled(FormControlLabel)`
  .control-label,
  &.control-label {
    white-space: nowrap;

    &__checkbox {
      .icon-correct-symbol {
        color: ${rgba(MAIN_BLACK, 0.8)};

        &:before {
          border-width: 2px;
        }

        &.default {
          &:before {
            border-color: ${WHITE};
          }
        }
      }
    }

    .MuiFormControlLabel-label {
      color: ${WHITE};
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
    }
  }
`;

export const SelectStyled = styled(Select)`
  .select,
  &.select {
    background-color: ${WHITE};

    &:hover,
    &:focus,
    &.Mui-focused,
    &.Mui-disabled {
      background-color: ${WHITE};
    }

    .MuiSelect-root {
      padding: 9px 40px 9px 12px;

      font-size: 17px;
      font-weight: 500;
      line-height: 30px;
    }

    .MuiSelect-iconFilled {
      right: 12px;
    }

    .MuiPaper-root {
      margin-top: -4px;
    }

    .MuiList-root {
      max-height: 274px;
      padding: 4px 0;

      ${breakpoints.down('sm')} {
        max-height: 166px;
      }
    }

    &__option {
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      padding: 12px;
      white-space: normal;
      word-break: break-word;

      &.Mui-selected {
        font-weight: 500;
        background-color: transparent;
      }
    }
  }
`;

export default DialogStyled;
